import { ICampaign } from 'interfaces/campaigns';
import axios, { Response } from 'services';

export interface IProductSResponse {
	items: ICampaign[];
	status: string;
};
export const getAdvertisingCampaigns = (slug: string, subclientId: string | number): Response<IProductSResponse> => {
	return axios.get(`/partners/${slug}/campaigns`, { params: { subclient_id: subclientId } });
};

export const getAdvertisingCampaignById = (slug: string, campaignId: string): Response<ICampaign> => {
	return axios.get(`/partners/${slug}/campaigns/${campaignId}`);
};

export interface ICreateAdvertisingCampaignRequest {
	slug: string;
	payload:{
		company_id: number;
		subclient_id: number;
		name: string;
		offer_id: number | null;
		asr_balance_dict_id: number | null;
		options: {
		  type: string;
		  url?: string;
		};
	};
};
export const createAdvertisingCampaign = ({ slug, payload }: ICreateAdvertisingCampaignRequest): Response<ICampaign> => {
	return axios.post(`/partners/${slug}/campaigns`, payload);
};

export interface ICheckAdvertisingCampaignStatusResponse {
	state: string;
};
export const checkAdvertisingCampaignStatus = (slug: string, campaignId: string): Response<ICheckAdvertisingCampaignStatusResponse> => {
	return axios.get(`/partners/${slug}/campaigns/${campaignId}/check_partner`);
};

export interface IStartCampaignRequest {
	slug: string;
	id: string | number;
	payload: {
		partner_type: string;
		budgetType: string;
		duration: string;
	}
};
export const startAdvertisingCampaign = ({ slug, id, payload }: IStartCampaignRequest): Response<void> => {
	return axios.post(`partners/${slug}/campaigns/${id}/launch`, { partner_params: payload });
};

export interface IPayCampaignRequest {
	slug: string;
	id: string | number;
	payload: {
		subclient_id: string | number;
		campaign_type: string;
		campaign_subtype: string;
		duration: string;
		branding: boolean;
		geo_id: string | number;
	}
};
export const payAdvertisingCampaign = ({ slug, id, payload }: IPayCampaignRequest): Response<void> => {
	return axios.post(`partners/${slug}/campaigns/${id}/pay`, payload);
};
